export const twentyFourHoursInMs = 1000 * 60 * 60 * 24;

export const countFn = (min, max) => {
  let countArr = [];
  for (let i = min; i <= max; i++) {
    let data = new Object();
    data.id = i;
    data.text = i;
    countArr.push(data);
  }
  return countArr;
};
